import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  flex: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${({ theme }) => theme.spacing(16, 0, 8, 0)};
`;

const Img = styled.img`
  width: 100%;
  height: ${({ height }) => `${height}px`};
  object-fit: contain;
`;

function Image({ src, height }) {
  return (
    <Container>
      <Img src={src} alt="Modal icon" height={height} />
    </Container>
  );
}

Image.propTypes = {
  src: PropTypes.string,
  height: PropTypes.number,
};

export default Image;
